import React from 'react';

import GalleryDemoLayout from './GalleryDemoLayout';
import { useGalleryLightbox } from './GalleryLightbox';
import { PHOTOS } from './galleryDemoData';

/* Demo 7 — 3D flip cards. Each card flips in 3D on hover to reveal its
   caption on the back; click opens the lightbox. */
const GalleryFlip = () => {
    const lb = useGalleryLightbox(PHOTOS);

    return (
        <GalleryDemoLayout
            demoLabel="Demo 7"
            kicker="3D Flip Cards"
            title="Flip To Discover"
            lead="Hover a card and it flips over in 3D to reveal the story behind the moment. Click any card to open it full-screen."
        >
            <div className="wrap">
                <div className="gflipgrid">
                    {PHOTOS.map((p, i) => (
                        <button
                            type="button"
                            className={"gflip reveal d" + ((i % 4) + 1)}
                            key={i}
                            onClick={() => lb.open(i)}
                            aria-label={`View photo: ${p.cap}`}
                        >
                            <span className="gflip__inner">
                                <span className="gflip__face gflip__front">
                                    <img src={p.src} alt={p.cap} loading="lazy" />
                                </span>
                                <span className="gflip__face gflip__back">
                                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
                                        <path d="M11 8v6M8 11h6M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                    <span className="gflip__cap">{p.cap}</span>
                                    <span className="gflip__view">View Photo</span>
                                </span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
            {lb.lightbox}
        </GalleryDemoLayout>
    );
};

export default GalleryFlip;
